/**
 * defa.collections.powerAlerts
 * A Collection of PowerAlert
 * @version 1.2.0
 */
import PowerAlert from './model-power-alert';

const PowerAlerts = Bb.Collection.extend( {
	
	// ------------------------------------------------
	// Setup
	// ------------------------------------------------
	
	model : PowerAlert,
	
	// ------------------------------------------------
	// Event Handlers
	// ------------------------------------------------
	
	// ------------------------------------------------
	// Other functions
	// ------------------------------------------------
	
} );


export default PowerAlerts;